import { create } from 'zustand'

type AuthTab = 'login' | 'register' | 'forgot' | 'reset'
type SessionEndedReason = 'idle' | 'expired'

interface UiState {
  authModal: { open: boolean; tab: AuthTab; resetToken?: string }
  openAuthModal: (tab?: AuthTab, resetToken?: string) => void
  closeAuthModal: () => void
  // Odhlášení (neaktivita / vypršení relace) — zobrazí přátelskou obrazovku.
  sessionEnded: SessionEndedReason | null
  endSession: (reason: SessionEndedReason) => void
  clearSession: () => void
}

export const useUiStore = create<UiState>((set) => ({
  authModal: { open: false, tab: 'login' },
  openAuthModal: (tab = 'login', resetToken?: string) =>
    set({ authModal: { open: true, tab, resetToken } }),
  closeAuthModal: () => set((s) => ({ authModal: { ...s.authModal, open: false } })),

  sessionEnded: null,
  endSession: (reason) => set({ sessionEnded: reason, authModal: { open: false, tab: 'login' } }),
  clearSession: () => set({ sessionEnded: null }),
}))
